/* eslint-disable @typescript-eslint/prefer-as-const */
/* eslint-disable react/require-default-props */
/* eslint-disable dot-notation */
import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { Form } from "@unform/web";
import { FormHandles } from "@unform/core";
import { Container } from "./styles";
import { useToast } from "../../../../../hooks/toast";
import CoreService from "../../../../../services/core";
import FileInputSpecial from "../FileInputSpecial";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  color: "#472b74",
  borderRadius: "12px",
};

interface ModalImagemProps {
  open?: boolean;
  handleClose?: () => void;
  id?: any;
}

const ModalImagem: React.FC<ModalImagemProps> = ({ open, handleClose, id }) => {
  const { addToast } = useToast();
  const services = { coreServices: new CoreService() };
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        if (!id) return;

        const file: File | undefined = data["backgroundbannerfile"];

        if (!file) {
          addToast({
            type: "error",
            title: "Nenhum arquivo selecionado",
            description: "Selecione uma imagem antes de enviar.",
          });
          return;
        }

        const formData = new FormData();
        formData.append("value_image", file);

        const config = {
          headers: { "Content-Type": "multipart/form-data" },
        };

        setLoading(true);

        await services.coreServices.patchSettingsID(id, formData, config);

        addToast({
          type: "success",
          title: "Imagem atualizada",
          description: "A imagem foi enviada com sucesso.",
        });

        handleClose?.();
        window.location.reload();
      } catch (err: any) {
        console.error(err);

        addToast({
          type: "error",
          title: "Erro ao enviar imagem",
          description: "Verifique o arquivo e tente novamente.",
        });
      } finally {
        setLoading(false);
      }
    },
    [id]
  );

  return (
    <Container>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Alterar imagem do ID: {id}
          </Typography>

          <Typography sx={{ mt: 2, mb: 2 }}>
            Anexe a nova imagem abaixo
          </Typography>

          {/* FORM */}
          <Form ref={formRef} onSubmit={handleSubmit}>
            <FileInputSpecial
              name="backgroundbannerfile"
              title="Selecionar Arquivo"
              maxWidth={1900}
              maxHeight={1900}
              maxSizeKB={500}
              quality={0.7}
            />

            <Button
              type="submit"
              fullWidth
              sx={{
                mt: 2,
                backgroundColor: "var(--purple)",
                color: "white",
                ":hover": { color: "var(--orange)" },
              }}
            >
              {loading ? "Enviando..." : "Alterar"}
            </Button>
          </Form>
        </Box>
      </Modal>
    </Container>
  );
};

export default ModalImagem;
